(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-tilbud-hero"] && !Shopify.designMode) return;
  try {
    
  class DbTilbudHero extends HTMLElement {
    connectedCallback() {
      this.spor = this.querySelector('.db-hero__spor');
      if (!this.spor) return;

      this.lysbilder = Array.from(this.querySelectorAll('.db-hero__lysbilde'));
      this.prikker = Array.from(this.querySelectorAll('[data-db-prikk]'));
      this.antall = this.lysbilder.length;
      this.indeks = 0;
      this.timer = null;

      const forrige = this.querySelector('[data-db-forrige]');
      const neste = this.querySelector('[data-db-neste]');
      if (forrige) forrige.addEventListener('click', () => this.gaTil(this.indeks - 1, true));
      if (neste) neste.addEventListener('click', () => this.gaTil(this.indeks + 1, true));

      this.prikker.forEach((prikk) => {
        prikk.addEventListener('click', () => this.gaTil(Number(prikk.dataset.dbPrikk), true));
      });

      this.spor.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.lesAvPosisjon(), 90);
      }, { passive: true });

      this.addEventListener('mouseenter', () => this.stopp());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stopp());
      this.addEventListener('focusout', () => this.start());

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopp() : this.start();
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.gaTil(this.indeks - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.gaTil(this.indeks + 1, true); }
      });

      this.start();
    }

    disconnectedCallback() {
      this.stopp();
    }

    lesAvPosisjon() {
      const bredde = this.spor.clientWidth;
      if (!bredde) return;
      const ny = Math.round(this.spor.scrollLeft / bredde);
      if (ny !== this.indeks) {
        this.indeks = ny;
        this.oppdaterPrikker();
      }
    }

    gaTil(mal, manuelt) {
      if (this.antall < 1) return;
      this.indeks = (mal + this.antall) % this.antall;
      this.spor.scrollTo({ left: this.spor.clientWidth * this.indeks, behavior: 'smooth' });
      this.oppdaterPrikker();
      if (manuelt) this.start();
    }

    oppdaterPrikker() {
      this.prikker.forEach((prikk, i) => {
        const aktiv = i === this.indeks;
        prikk.classList.toggle('er-aktiv', aktiv);
        prikk.setAttribute('aria-selected', aktiv ? 'true' : 'false');
      });
    }

    start() {
      this.stopp();
      if (this.dataset.autoplay !== 'true' || this.antall < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const intervall = Number(this.dataset.intervall) || 6000;
      this.timer = window.setInterval(() => this.gaTil(this.indeks + 1, false), intervall);
    }

    stopp() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('db-tilbud-hero')) {
    customElements.define('db-tilbud-hero', DbTilbudHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
